export default __webpack_public_path__ + "static/media/pratham.78f5c564.png";